import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
	name: 'safeHtml',
	standalone: true
})
export class SafeHtmlPipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) {}

	public transform(value: string, ..._args: string[]): SafeHtml {
		return this.sanitizer.bypassSecurityTrustHtml(value);
	}
}
